<template>
    <div>
        <div v-if="this.$store.state.device.isDesktop">
            <navbarTop></navbarTop>
            <sideBar></sideBar>
            <div class="desktop_container">
                 <div v-if="width>1200">
                    <b-row style="margin-bottom: 2%">
                        <b-col cols="4">
                            <div class="card col-height">
                                <!-- Card Header - Dropdown -->
                                <div class=" py-3 d-flex flex-row align-items-center justify-content-between" style="border-radius: 22px; background-color: #ffffff; padding-right: 5%; padding-left: 5%">
                                    <h6 class="m-0 font-weight-bold" :style="{'color': this.$store.state.device.color}">
                                        {{ $t('pages.Dashboard.PieChartTitle') }}
                                    </h6>
                                    <div style="right: 0; padding-right: 10px">
                                        <h6 class="m-0 font-weight-bold" :style="{'color': this.$store.state.device.color}">
                                            {{ racio_quotas }}
                                        </h6>
                                    </div>
                                </div>
                                <!-- Card Body -->
                                <div class="card-body">
                                    <div id="pieChart" style="zoom: 100%;">
                                        <apexchart
                                                type="pie"
                                                :options="chartOptionsPie"
                                                :series="seriesPie"
                                        />
                                    </div>
                                </div>
                            </div>
                        </b-col>
                        <b-col cols="4">
                            <div class="card col-height">
                                <!-- Card Header - Dropdown -->
                                <div class=" py-3 d-flex flex-row align-items-center justify-content-between" style="border-radius: 22px; background-color: #ffffff; padding-right: 5%; padding-left: 5%">
                                    <h6 class="m-0 font-weight-bold" :style="{'color': this.$store.state.device.color}">
                                        {{ $t('pages.Dashboard.LineChartTitle') }}
                                    </h6>
                                </div>
                                <!-- Card Body -->
                                <div class="card-body">
                                    <div id="lineChart" style="zoom: 100%">
                                        <apexchart
                                                type="line"
                                                width="100%"
                                                :options="chartOptionsLine"
                                                :series="seriesLine"
                                        />
                                    </div>
                                </div>
                            </div>
                        </b-col>
                    </b-row>
                 </div>
                 <div v-else>
                     <b-row v-if="width>800" style="margin-bottom: 2%">
                        <b-col cols="6">
                            <div class="card col-height">
                                <!-- Card Header - Dropdown -->
                                <div class=" py-3 d-flex flex-row align-items-center justify-content-between" style="border-radius: 22px; background-color: #ffffff; padding-right: 5%; padding-left: 5%">
                                    <h6 class="m-0 font-weight-bold" :style="{'color': this.$store.state.device.color}">
                                        {{ $t('pages.Dashboard.PieChartTitle') }}
                                    </h6>
                                    <div style="right: 0; padding-right: 10px">
                                        <h6 class="m-0 font-weight-bold" :style="{'color': this.$store.state.device.color}">
                                            {{ racio_quotas }}
                                        </h6>
                                    </div>
                                </div>
                                <!-- Card Body -->
                                <div class="card-body">
                                    <div id="pieChart" style="zoom: 100%;">
                                        <apexchart
                                                type="pie"
                                                :options="chartOptionsPie"
                                                :series="seriesPie"
                                        />
                                    </div>
                                </div>
                            </div>
                        </b-col>
                        <b-col cols="6">
                            <div class="card col-height">
                                <!-- Card Header - Dropdown -->
                                <div class=" py-3 d-flex flex-row align-items-center justify-content-between" style="border-radius: 22px; background-color: #ffffff; padding-right: 5%; padding-left: 5%">
                                    <h6 class="m-0 font-weight-bold" :style="{'color': this.$store.state.device.color}">
                                        {{ $t('pages.Dashboard.LineChartTitle') }}
                                    </h6>
                                </div>
                                <!-- Card Body -->
                                <div class="card-body">
                                    <div id="lineChart" style="zoom: 100%">
                                        <apexchart
                                                type="line"
                                                width="100%"
                                                :options="chartOptionsLine"
                                                :series="seriesLine"
                                        />
                                    </div>
                                </div>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row v-if="width<800" style="margin-bottom: 2%">
                        <b-col cols="12" style="margin-bottom: 50px">
                            <div class="card col-height">
                                <!-- Card Header - Dropdown -->
                                <div class=" py-3 d-flex flex-row align-items-center justify-content-between" style="border-radius: 22px; background-color: #ffffff; padding-right: 5%; padding-left: 5%">
                                    <h6 class="m-0 font-weight-bold" :style="{'color': this.$store.state.device.color}">
                                        {{ $t('pages.Dashboard.PieChartTitle') }}
                                    </h6>
                                    <div style="right: 0; padding-right: 10px">
                                        <h6 class="m-0 font-weight-bold" :style="{'color': this.$store.state.device.color}">
                                            {{ racio_quotas }}
                                        </h6>
                                    </div>
                                </div>
                                <!-- Card Body -->
                                <div class="card-body">
                                    <div id="pieChart" style="zoom: 100%;">
                                        <apexchart
                                                type="pie"
                                                :options="chartOptionsPie"
                                                :series="seriesPie"
                                        />
                                    </div>
                                </div>
                            </div>
                        </b-col>
                        <b-col cols="12">
                            <div class="card col-height">
                                <!-- Card Header - Dropdown -->
                                <div class=" py-3 d-flex flex-row align-items-center justify-content-between" style="border-radius: 22px; background-color: #ffffff; padding-right: 5%; padding-left: 5%">
                                    <h6 class="m-0 font-weight-bold" :style="{'color': this.$store.state.device.color}">
                                        {{ $t('pages.Dashboard.LineChartTitle') }}
                                    </h6>
                                </div>
                                <!-- Card Body -->
                                <div class="card-body">
                                    <div id="lineChart" style="zoom: 100%">
                                        <apexchart
                                                type="line"
                                                width="100%"
                                                :options="chartOptionsLine"
                                                :series="seriesLine"
                                        />
                                    </div>
                                </div>
                            </div>
                        </b-col>
                    </b-row>
                 </div>
            </div>
        </div>
        <div style="width: 100%; height: 100%;" v-if="this.$store.state.device.isMobile">
            <navbarTop></navbarTop>
            <navbarBottom></navbarBottom>
            <div style="padding: 80px 16px 16px;">
                <div style="margin-bottom: 25%;">
                    <div class="card mb-4" style="border-radius: 22px; margin-right: 1%;
                                        -webkit-box-shadow: 3px 3px 6px 0px rgba(209,209,209,1);
                                        -moz-box-shadow: 3px 3px 6px 0px rgba(209,209,209,1);
                                        box-shadow: 3px 3px 6px 0px rgba(209,209,209,1);">
                        <!-- Card Header - Dropdown -->
                        <div class=" py-3 d-flex flex-row align-items-center justify-content-between" style="border-radius: 22px; background-color: #ffffff; padding-right: 5%; padding-left: 5%">
                            <h6 class="m-0 font-weight-bold" :style="{'color': this.$store.state.device.color}">
                                {{ $t('pages.Dashboard.PieChartTitle') }}
                            </h6>
                            <div style="right: 0; padding-right: 10px">
                                <h6 class="m-0 font-weight-bold" :style="{'color': this.$store.state.device.color}">
                                    {{ racio_quotas }}
                                </h6>
                            </div>
                        </div>
                        <!-- Card Body -->
                        <div class="card-body">
                            <div id="pieChart" style="zoom: 100%;">
                                <apexchart
                                        type="pie"
                                        :options="chartOptionsPie"
                                        :series="seriesPie"
                                />
                            </div>
                        </div>
                    </div>
                    <div class="card mb-4" style="border-radius: 22px; margin-right: 1%;
                                        -webkit-box-shadow: 3px 3px 6px 0px rgba(209,209,209,1);
                                        -moz-box-shadow: 3px 3px 6px 0px rgba(209,209,209,1);
                                        box-shadow: 3px 3px 6px 0px rgba(209,209,209,1);">
                        <!-- Card Header - Dropdown -->
                        <div class=" py-3 d-flex flex-row align-items-center justify-content-between" style="border-radius: 22px; background-color: #ffffff; padding-right: 5%; padding-left: 5%">
                            <h6 class="m-0 font-weight-bold" :style="{'color': this.$store.state.device.color}">
                                {{ $t('pages.Dashboard.LineChartTitle') }}
                            </h6>
                        </div>
                        <!-- Card Body -->
                        <div class="card-body">
                            <div id="lineChart" style="zoom: 100%">
                                <apexchart
                                        type="line"
                                        width="100%"
                                        :options="chartOptionsLine"
                                        :series="seriesLine"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import NavbarTop from "../components/navbarTop";
  import navbarBottom from "../components/navbarBottom";
  import sideBar from "../components/sideBar";
  import { Hooper, Slide, Navigation as HooperNavigation } from 'hooper';
  import 'hooper/dist/hooper.css';
  import {feeValues} from "../api/Fee/apiFee.js";
  import {lineChartTimeMembers} from "../api/Member/apiMember.js";
  const qs = require("query-string");
  export default {
    name: "dashboard",
    components: {
      NavbarTop,
      navbarBottom,
      sideBar,
      Hooper,
      Slide,
      HooperNavigation
    },
    data() {
      return {
        width: null,
        racio_quotas: "",
        seriesPie: [],
        chartOptionsPie: {},
        seriesLine: [],
        chartOptionsLine: {}
      };
    },
    methods: {
        LightenDarkenColor: function(col, amt) {
              var usePound = false;
              if (col[0] == "#") {
                  col = col.slice(1);
                  usePound = true;
              }
              var num = parseInt(col,16);
              var r = (num >> 16) + amt;
              if (r > 255) r = 255;
              else if  (r < 0) r = 0;
              var b = ((num >> 8) & 0x00FF) + amt;
              if (b > 255) b = 255;
              else if  (b < 0) b = 0;
              var g = (num & 0x0000FF) + amt;
              if (g > 255) g = 255;
              else if (g < 0) g = 0;
              return (usePound?"#":"") + (g | (b << 8) | (r << 16)).toString(16);
        }
    },
    mounted() {
        let spinner1 = this.$loading.open();
        this.width = Math.max(self.innerWidth || 0, document.documentElement.clientWidth || 0, document.body.clientWidth || 0);
        feeValues()
              .then(response => {
                var quotas_pagas = response.data.body[0];
                var quotas_nao_pagas = response.data.body[1];
                var total = quotas_pagas + quotas_nao_pagas;
                var racio = quotas_pagas / total;
                this.racio_quotas = Math.round(racio * 100) + " %";

                this.axios.post("https://iochart-dev.herokuapp.com/pieChart",
                                qs.stringify({
                                  type: "options",
                                  data:   '{"id":"pieChart","type":"pie","data":{"Pago": "' +
                                          quotas_pagas +
                                          '","Não Pago": "' +
                                          quotas_nao_pagas +
                                          '"}}'
                                }),{headers: {"Content-Type": "application/x-www-form-urlencoded"} }
                        ).then(response => {
                          if (response.status == 200) {
                            this.seriesPie = response.data.series;
                            this.chartOptionsPie = response.data.chartOptions;
                            this.chartOptionsPie.dataLabels = {enabled: false};
                            let light_main_color = this.LightenDarkenColor(this.$store.state.device.color, 150);
                            this.chartOptionsPie.colors = [this.$store.state.device.color, light_main_color];
                            spinner1.close();
                          }
                        }).catch(error => {
                            spinner1.close();
                            console.log(error);
                        });
              });

        let spinner2 = this.$loading.open();
        lineChartTimeMembers()
            .then(response => {
                let x = JSON.stringify(response.data.body.x);
                let y = JSON.stringify(response.data.body.y);

                this.axios.post("https://iochart-dev.herokuapp.com/lineChart",
                        qs.stringify({
                          type: "options",
                          data: '{  \n' +
                                  '   "id":"lineChart",\n' +
                                  '   "type":"line",\n' +
                                  '   "color":"fff", \n' +
                                  '   "title":"",\n' +
                                  '   "series": [{"name":"Members evolution", "data": '+y+'}],\n' +
                                  '   "categories": '+x+'\n' +
                                  '}'
                        }),{headers: {"Content-Type": "application/x-www-form-urlencoded"} }
                ).then(response => {
                  if (response.status == 200) {
                    this.seriesLine = response.data.series;
                    this.chartOptionsLine = response.data.chartOptions;
                    this.chartOptionsLine.dataLabels = {enabled: false};
                    this.chartOptionsLine.yaxis = {tickAmount: 3};
                    this.chartOptionsLine.chart = {};
                    this.chartOptionsLine.chart.toolbar = {show: false};
                    this.chartOptionsLine.colors = [this.$store.state.device.color];
                    spinner2.close();
                  }
                }).catch(error => {
                    spinner2.close();
                    console.log(error);
                });
              });

    }
  };
</script>

<style>
    .card-body div { margin: auto; }
    .col-height { height: 100%; }
    b-col div { margin: 0; }
</style>
